"use client";

import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { Modal } from "@/components/Modal";
import { logError } from "@/utils/logError";

export function UnsaveConversionModal({
  open,
  closeModal,
  unsaveConversion,
}: {
  open: boolean;
  closeModal: () => void;
  unsaveConversion: () => Promise<void>;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const unsaveHandler = async () => {
    setIsLoading(true);
    try {
      await unsaveConversion();
      closeModal();
    } catch (error) {
      logError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      closeModal={isLoading ? null : closeModal}
      title="Unsave conversion"
      widthMode="normal"
    >
      <div className="space-y-4">
        <div className="space-y-4 sm:flex sm:items-center sm:gap-x-4 sm:space-y-0">
          <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          </div>
          <p className="text-center text-sm text-gray-500 sm:text-left">
            Are you sure you want to unsave this conversion? Older conversions
            will be deleted once they are unsaved.
          </p>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={closeModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="error"
            onClick={unsaveHandler}
            loading={isLoading}
            disabled={isLoading}
          >
            Unsave
          </Button>
        </div>
      </div>
    </Modal>
  );
}
